__turbopack_context__.v({
  "arrowDownIcon": "styles-module-scss-module__OS9enW__arrowDownIcon",
  "footerLinksContent": "styles-module-scss-module__OS9enW__footerLinksContent",
  "headingLink": "styles-module-scss-module__OS9enW__headingLink",
  "headingLinkWithChild": "styles-module-scss-module__OS9enW__headingLinkWithChild",
  "hiddenFooterLinks": "styles-module-scss-module__OS9enW__hiddenFooterLinks",
  "hiddenMenuContainer": "styles-module-scss-module__OS9enW__hiddenMenuContainer",
  "readmoreCTA": "styles-module-scss-module__OS9enW__readmoreCTA",
  "showFooterLinks": "styles-module-scss-module__OS9enW__showFooterLinks",
  "showMoreButton": "styles-module-scss-module__OS9enW__showMoreButton",
  "subMenuItem": "styles-module-scss-module__OS9enW__subMenuItem",
});
